// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

const RowLetter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  border-bottom: 1px solid ${buildColor("grey", "300")};
  background-color: ${buildColor("white", "100")};
  padding: 12px 16px;
  color: ${buildColor("grey", "800")};
  font-size: 14px;
  font-family: ${fontCondensed};
  letter-spacing: 0;
`;

export default RowLetter;
